module.exports = __webpack_public_path__ + "img/msNET.1bf8f89f.png";